import script from "./CategoryDeleteList.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./CategoryDeleteList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryDeleteList.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./CategoryDeleteList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__